var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeneficios(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.937,
    height: 64.28,
    viewBox: "0 0 43.937 64.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #471936;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Beneficios",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    className: "cls-1",
    d: "M34.84,50.064a30.389,30.389,0,0,0-5.014-1.277c1.172-1.377,2.422-2.9,3.677-4.536,6.924-9,10.434-16.5,10.434-22.282A21.968,21.968,0,1,0,0,21.968c0,5.817,3.511,13.325,10.434,22.313,1.25,1.622,2.493,3.139,3.661,4.509a30.394,30.394,0,0,0-5,1.274c-5.223,1.867-6.32,4.371-6.32,6.148s1.1,4.281,6.32,6.146A39.661,39.661,0,0,0,21.968,64.28,39.661,39.661,0,0,0,34.84,62.358c5.223-1.865,6.32-4.371,6.32-6.146S40.065,51.931,34.84,50.064ZM3.767,21.968a18.2,18.2,0,0,1,36.4,0c0,4.858-3.328,11.757-9.625,19.951a122.833,122.833,0,0,1-8.58,9.942,121.836,121.836,0,0,1-8.548-9.877C7.1,33.787,3.767,26.869,3.767,21.968ZM33.575,58.811a35.877,35.877,0,0,1-11.606,1.7,35.868,35.868,0,0,1-11.605-1.7c-2.778-.994-3.82-2.116-3.82-2.6s1.041-1.606,3.82-2.6a30.048,30.048,0,0,1,6.721-1.441c2.045,2.233,3.461,3.618,3.57,3.728l1.318,1.286L23.286,55.9c.109-.107,1.518-1.491,3.557-3.728a30.055,30.055,0,0,1,6.731,1.442c2.782,1,3.82,2.123,3.82,2.6S36.357,57.818,33.575,58.811Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    className: "cls-1",
    d: "M113.34,94.086a1.508,1.508,0,0,0-2.866.925,9.352,9.352,0,1,1-6.38-6.133,1.509,1.509,0,1,0,.81-2.907,12.369,12.369,0,1,0,8.447,8.115Z",
    transform: "translate(-79.575 -75.451)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    className: "cls-1",
    d: "M213.971,107.4l-.014-.014a1.508,1.508,0,0,0-2.127,2.133l.014.014a1.508,1.508,0,1,0,2.133-2.133Z",
    transform: "translate(-184.55 -93.346)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeneficios);
export default __webpack_public_path__ + "static/media/Beneficios.51e08e719e327c125d60e765392c3682.svg";
export { ForwardRef as ReactComponent };